import { useAppContext, AppContextProvider } from "./AppContext";
import { useNotificationContext, NotificationContextProvider } from "./NotificationContext";
import { useUserContext, UserContextProvider } from "./UserContext";

export { useAppContext, useNotificationContext, useUserContext };

export const providers = [AppContextProvider, NotificationContextProvider, UserContextProvider];
export const contexts = [useAppContext, useNotificationContext, useUserContext];